angular.module('bmsApp.sm.job')
	.controller('SMJobViewCtrl', function ($state,
										   $scope,
										   $q,
										   NoteSvc,
										   EmailSvc,
										   $ngBootbox,
										   SMJobSvc,
										   notify,
										   $window,
										   TaxHelperSvc,
										   SMCleaningServiceSvc,
										   AuthService,
										   VisitPhotoSvc,
											 $modal
										   ) {

		function init() {
			self.jobId = $state.params.jobId;
			$q.all({
				job: SMJobSvc.read(self.jobId),
				vatRate: TaxHelperSvc.setVatRate(),
				currentUser: AuthService.getUser(),
			})
				.then(function (responses) {
					self.job = responses.job.data.sm_job;
					$scope.franchise = responses.currentUser.franchise;
					self.loading = false;
					angular.extend($scope, {
						job: {
							name: angular.copy(self.job.id)
						}
					});
					self.loading = false;
				});
		}

		function addNote() {
			var note = {
				object_type: 'App\\Models\\Sm\\Job',
				object_id: self.jobId
			};
			NoteSvc.showSaveModal(note);
		}

		// function addComplaint() {
		// 	var complaint = {
		// 		object_type: 'App\\Models\\Sm\\Job',
		// 		object_id: self.jobId
		// 	};
		// 	ComplaintSvc.showSaveModal(complaint);
		// }

		function copyQuote() {
			SMJobSvc.showCopyQuoteModal(self.job)
				.then(function (result) {
					notify({
						message: 'Successfully copied'
					});
					$state.go('main.sm.quote.index.view', {quoteId: result.id});
				});
		}

		function emailForm(emailAddress, objectType, objectId) {
			var email = {
				to: emailAddress,
				object_type: objectType,
				object_id: objectId
			};
			EmailSvc.showSendModal(email, self.job.customer);
		}

		function cancelJob() {
			SMJobSvc.cancel.showModal(self.job).then(function(result) {
				self.job = result;
			});
		}

		function printQuoteForm() {
			$ngBootbox.customDialog({
				message: "Would you like to save quote to notes?",
				buttons: {
					confirm: {
						label: 'Yes Please',
						className: 'btn-success',
						callback: function() {
							$window.open('sm/quote-form?save=true&type=filled&quote_id=' + self.job.id, '_blank');
						}
					},
					cancel: {
						label: 'No Thanks',
						className: 'btn-success',
						callback: function() {
							$window.open('sm/quote-form?type=filled&quote_id=' + self.job.id, '_blank');
						}
					}
				},
				callback: function (result) {
					console.log('This was logged in the callback: ' + result);
				}
			});
		}

		function reinstateCancelledJob() {
			SMJobSvc.cancel.reinstate({
				jobId: self.job.id
			}).then(function(response) {
				self.job = response.data.sm_job;
			})
		}

		function orderConfirmation() {
			$ngBootbox.customDialog({
				message: "Would you like to email or print this order confirmation?",
				buttons: {
					confirm: {
						label: 'Email',
						className: 'btn-success',
						callback: function() {
							generateOrderConfirmation('email');
						}
					},
					cancel: {
						label: 'Print',
						className: 'btn-success',
						callback: function() {
							generateOrderConfirmation('print');
						}
					}
				},
				callback: function (result) {
					console.log('This was logged in the callback: ' + result);
				}
			});
		}

		function generateOrderConfirmation(method) {
			if (method == 'email') {
				SMJobSvc.orderConfirmationEmail({
					jobId: self.jobId,
					method: method
				}).then(function(response) {
					notify({
						message: 'Order confirmation sent!'
					});
					self.job.customer_confirmation_last_sent_at = moment();
				}, function (errors) {
					notify({
						message: errors[0],
						classes: 'error',
						duration: '0'
					});
				});
			}
			else {
				self.job.customer_confirmation_last_sent_at = moment();
				$window.open('api/sm/job/orderConfirmationPrint/' + self.jobId, '_blank');
			}
		}

		function showCustomerNotes() {
			self.notes.activeObjectType = 'App\\Models\\Crm\\Customer';
			self.notes.activeObjectId = self.job.customer.id;
		}

		function showJobNotes() {
			self.notes.activeObjectType = 'App\\Models\\Sm\\Job';
			self.notes.activeObjectId = self.job.id;
		}

		function showJobComplaints() {
			self.complaints.activeObjectType = 'App\\Models\\Sm\\Job';
			self.complaints.activeObjectId = self.job.id;
		}


		function showMaterialTestPhotos(visit){
			SMCleaningServiceSvc.showMaterialTestPhotosModal(null, visit)
				.then(function (result) {
				});

		}
		function showRugCleaningPhotos(visit){
			SMCleaningServiceSvc.showRugCleaningPhotosModal(null, visit)
				.then(function (result) {
				});
		}

		$scope.uploadPhoto = function(isBefore, visit, visitType) {
			var modalInstance = $modal.open({
				animation: true,
				templateUrl: 'ng/global/photo/templates/UploadPhotoModal.html',
				controller: 'UploadPhotoModalCtrl',
				size: 'md',
				resolve: {
					isBefore: function () {
						return isBefore ? 1 : 0;
					},
					visitType: function() {
						return visitType;
					},
					visitId: function() {
						return angular.isObject(visit) ? visit.id : visit;
					}
				}
			});

			modalInstance.result.then(function (result) {
				self.loading = true;
				if (result.data.success) {
					notify({
						message: isBefore ? 'Uploaded before photo' : 'Uploaded after photo'
					});
					$scope.SMJobViewCtrl.methods.init();
					self.loading = false;
				}
				else {
					notify({
						message: result.error,
						classes: 'error'
					});
				}
			}, function () {
				// closed
			});
		}

		var self = $scope.SMJobViewCtrl = {
			loading: true,
			methods: {
				init: init,
				emailForm: emailForm,
				addNote: addNote,
				// addComplaint: addComplaint,
				copyQuote: copyQuote,
				orderConfirmation: orderConfirmation,
				printQuoteForm: printQuoteForm,
				cancelJob: cancelJob,
				reinstateCancelledJob: reinstateCancelledJob,
				showCustomerNotes: showCustomerNotes,
				showJobNotes: showJobNotes,
				showJobComplaints: showJobComplaints,
				showMaterialTestPhotos: showMaterialTestPhotos,
				showRugCleaningPhotos: showRugCleaningPhotos,
				uploadVisitPhoto: uploadVisitPhoto,
			},
			notes: {
				view: 'job',
				api: {}
			},
			complaints: {
				api: {},
			},
			photos: {
				view: 'job',
				api: {}
			}
		};

		function uploadVisitPhoto(fileDetails){

			var self = this;
			//self.uploadedFiles = [];
			self.drag = {
				isDragging: false
			};

			angular.forEach(fileDetails.$files, function(file) {
				//self.uploadedFiles.push(file);
				var postData=new FormData();

				postData.append('is_before', fileDetails.is_before);
				postData.append('object_id', fileDetails.object_id);
				postData.append('object_type', fileDetails.object_type);
				postData.append('file', file);

				VisitPhotoSvc.save(postData).then(function(response) {
					notify({
						message: 'Photo submitted.'
					});
					$rootScope.$broadcast('onTickedAdded');
					$modalInstance.close();
				});

			});

		}

	});
